// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2hG31","box":"WorkspacesBox_box__1lHFa","node":"WorkspacesBox_node__3-pdg"};